import { useMemo } from 'react';
import { useApi } from './api';

const sortByJersey = (players) =>
  players.sort((a, b) => {
    if (a.number < b.number) return -1;
    if (a.number > b.number) return 1;
    return 0;
  });

const sortByPositionAndJersey = (players) => ({
  goalkeepers: sortByJersey(
    players.filter((p) => p.position?.primary === 'Goalkeeper')
  ),
  defenders: sortByJersey(
    players.filter((p) =>
      ['Back', 'Centre-Back', 'Left-Back', 'Right-Back'].includes(
        p.position?.primary
      )
    )
  ),
  midfields: sortByJersey(
    players.filter((p) =>
      [
        'Midfield',
        'Defensive Midfield',
        'Central Midfield',
        'Attacking Midfield',
        'Attacking Central Midfield',
        'Left Winger',
        'Right Winger',
      ].includes(p.position?.primary)
    )
  ),
  forwards: sortByJersey(
    players.filter((p) =>
      ['Forward', 'Centre Forward'].includes(p.position?.primary)
    )
  ),
});

export const useSquad = (abbrv) => {
  const [data, loading, error] = useApi(`team/squad?id=${abbrv}`);

  const squad = useMemo(
    () => (data?.squad ? sortByPositionAndJersey(data.squad) : null),
    [data, loading, error]
  );

  return [squad, loading, error];
};
